/* *************************************************
 zero_reports.js
 ***************************************************/
import * as setup from './datatables_setup';

$(function () {
  const table = $('#zero-report-table');
  const advancedSearchContainer = document.getElementById('advanced-search-zrd');
  const dataTableOptions = {
    displayLength: 25,
    processing: true,
    layout: {
      topStart: 'pageLength',
      topEnd: advancedSearchContainer,
      bottomStart: 'info',
      bottomEnd: 'paging'
    },
    language: {
      lengthMenu: "Show _MENU_ entries",
      processing: setup.tableStartProcessing(),
      emptyTable: "No data available in table",
      info: "Showing _START_ to _END_ of found entries"
    },
    preDrawCallback: function () {
      const show_accounts = table.hasClass('show-accounts');
      table.DataTable().column(0).visible(show_accounts);
      setup.tableStartProcessing();
    },
    drawCallback: function () {
      setup.tableStopProcessing();
    },
    serverSide: true,
    ajax: {
      url: $('#zero-report-table').data('source'),
      dataSrc: 'data'
    },
    pagingType: "simple",
    columns: [
      null, null, null, null, null,
      { className: "text-start", type: "string" },
      null,
      { className: "text-start", type: "string" },
      null, null
    ],
    order: [
      [9, "desc"]
    ]
  }
  let zeroReportsTable = table.DataTable(dataTableOptions);

  // Move to the first page after user changes par page option
  $('#zero-report-table').on('length.dt', function (e) {
    zeroReportsTable.page(0);
  })

  $('.dropdown-menu-file-listing').on('click', function (e) {
    e.stopPropagation();
  });

  $('#search-inp').on('keyup', function (e) {
    if (e.code == 'Enter') {
      generalSearch();
    }
  }); ``
  $('#search-files-table-btn').on('click', function () {
    generalSearch();
  });
  $('#advanced-search-files-table-btn').on('click', function (e) {
    e.preventDefault();
    advancedSearch();
  });
  $('#advanced-search-files-table-btn').on('keyup', function (e) {
    if (e.code == 'Enter') {
      e.preventDefault();
      advancedSearch();
    }
  });

  function accountNameSearch(accountNameInput = $('#account_name').val()) {
    zeroReportsTable.columns(0).search(accountNameInput).draw();
  }
  function pmpSearch(pmpSelectInput = $('.search-pmp-select').children("option:selected").val()) {
    zeroReportsTable.columns(1).search(pmpSelectInput).draw();
  }
  function submissionBeginDateSearch(beginDateInput = $('#submission_begin_date').val()) {
    zeroReportsTable.columns(7).search(beginDateInput).draw();
  }
  function submissionEndDateSearch(endDateInput = $('#submission_end_date').val()) {
    zeroReportsTable.columns(8).search(endDateInput).draw();
  }
  function generalSearch(searchInput = $('#search-inp').val()) {
    if (zeroReportsTable == null || zeroReportsTable == undefined) return;
    return zeroReportsTable.search(searchInput).draw()
  };
  function advancedSearch() {

    if (zeroReportsTable == null || zeroReportsTable == undefined) return;

    pmpSearch();
    submissionBeginDateSearch();
    submissionEndDateSearch();
    accountNameSearch();
  };
});